<template>
    <TxProductViewPortal>
<!--        <StudentPosterLoader>-->
            <div class="lm-index" :class="[mapLayout,$root.env]">
<!--                <TxZoomControl-->
<!--                        v-model="zoom"-->
<!--                        :disabled="mapBlock"-->
<!--                        :mapLayout="mapLayout"-->
<!--                />-->
<!--                <TxZoomBlocker-->
<!--                        v-model="mapBlock"-->
<!--                        :mapLayout="mapLayout"-->
<!--                />-->
                <TxBlockOverlay :active="false">
<!--                    <TxRendererProduct>-->
                    <TxRendererProduct
                            componentName="StudentPosterBorder"
                            :mapLayout="mapLayout"
                            :size="mapSize"
                    >
                        <StudentPosterProduct/>
                    </TxRendererProduct>
                </TxBlockOverlay>
            </div>
<!--        </StudentPosterLoader>-->
    </TxProductViewPortal>
</template>


<script>
    import StudentPosterModule from "@packages/tx-products/products/student-poster/store-mixin";

    export default {
        name: 'StudentPosterIndex',
        mixins: [StudentPosterModule()],
        data() {
            return {
                mapBlock: false,
            }
        },
        mounted() {
            if (this.$root.env === 'admin') {
                this.mapBlock = true;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .lm-index {
        background: url(./assets/lm-background.webp);
        background-size: cover;
        position: relative;
        padding-bottom: 50px;

        &.admin {
            padding-top: 40px !important;
            padding-bottom: 40px !important;
        }

        &.horizontal {
            background: none;
        }

        @media (max-width: 599px) {
            padding-bottom: 20px;
            background: none;
        }
        @media (min-width: 600px) {
            &.vertical {
                padding-top: 20px;
            }
        }
    }

</style>
